import { useTranslation } from 'react-i18next'

import styles from './AgentVerificationBulkRejectModal.module.scss'
import { BulkRejectException, CHECK_FAILED_OUTCOME } from './verifyBulkRejectOutcomes'
import { Badge, Table, TableBody, TableCell, TableProvider, TableRow } from '@percent/lemonade'

export function BulkRejectExceptionsTable({ exceptions }: Readonly<{ exceptions: BulkRejectException[] }>) {
  const { t } = useTranslation()

  return (
    <div className={styles.resultTableContainer} data-testid="av-bulk-reject-exceptions-table">
      <TableProvider
        columns={[
          { id: t('dialog.avBulkReject.verified.column.agentVerificationId') },
          { id: t('dialog.avBulkReject.verified.column.status') }
        ]}
        totalResults={exceptions.length}
        isLoading={false}
        illustration="no-results"
        emptyTableTitle={t('dialog.avBulkReject.verified.allRejected')}
      >
        <Table>
          <TableBody>
            {exceptions.map(({ agentVerificationId, outcome }) => {
              const isCheckFailed = outcome === CHECK_FAILED_OUTCOME

              return (
                <TableRow key={agentVerificationId}>
                  <TableCell>{agentVerificationId}</TableCell>
                  <TableCell>
                    <Badge variant={isCheckFailed ? 'default' : 'warning'}>
                      {isCheckFailed ? t('dialog.avBulkReject.verified.outcome.checkFailed') : outcome}
                    </Badge>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableProvider>
    </div>
  )
}
